import React, { useState, useEffect, useCallback } from "react";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Skeleton from "react-loading-skeleton";
import axios from "axios";
import { Image } from "react-bootstrap";

const PortfolioCard = ({ value, isDarkMode }) => {
  const {
    Name,
    imageLink1,
    imageLink2,
    imageSize,
    about,
    link: appLink,
  } = value;

  const [testing, setTesting] = useState({});

  const {
    name,
    description,
    svn_url,
    stargazers_count,
    languages_url,
    pushed_at,
    sitelink,
  } = testing;
  return (
    <Col md={6} style={{ margin: "15px 0px" }}>
      <Card
        className={`${
          isDarkMode ? "box-shadow-dark dark-theme-card" : "shadow-lg bg-white"
        } card p-3 mb-10 rounded h-100 m`}
      >
        <Card.Body>
          <div className="cardBody">
            <Card.Title
              className={`cardTitle ${isDarkMode ? "color-theme-light" : ""}`}
              as="h5"
            >
              {Name || <Skeleton />}{" "}
            </Card.Title>
            {appLink ? (
              <CardButtons isDarkMode={isDarkMode} appLink={appLink} />
            ) : (
              <Skeleton count={2} />
            )}
          </div>
          <div className="mainSection">
            <Card.Text
              className={`aboutCard ${isDarkMode ? "color_yellow " : ""}`}
            >
              {about || <Skeleton count={3} />}{" "}
            </Card.Text>
            <div className="imgWrapper">
              <div
                style={{
                  width: imageSize,
                }}
                className="portfolioImg1"
              >
                <Image
                  style={{ height: "100%" }}
                  src={imageLink1}
                  fluid
                  rounded
                  loading="lazy"
                />
              </div>
              <div
                style={{
                  width: imageSize,
                }}
                className="portfolioImg2"
              >
                <Image
                  style={{ height: "100%" }}
                  src={imageLink2}
                  fluid
                  rounded
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          {/* {value ? (
            <CardFooter
              star_count={stargazers_count}
              isDarkMode={isDarkMode}
              repo_url={svn_url}
              pushed_at={pushed_at}
            />
          ) : (
            <Skeleton />
          )} */}
        </Card.Body>
      </Card>
    </Col>
  );
};

const CardButtons = ({ svn_url, isDarkMode, appLink }) => {
  return (
    <>
      <a
        href={appLink}
        target=" _blank"
        className={`${
          isDarkMode
            ? "btn-outline-themelight color-theme-light"
            : "btn-outline-secondary"
        } btn`}
      >
        <i className="fas fa-external-link-alt" /> View App
      </a>
    </>
  );
};

const CardFooter = ({ star_count, isDarkMode, repo_url, pushed_at }) => {
  const [updated_at, setUpdated_at] = useState("0 mints");

  return (
    <p className="card-text">
      <a
        href={repo_url + "/stargazers"}
        target=" _blank"
        className="text-dark text-decoration-none"
      >
        <span
          className={`${
            isDarkMode ? "color-theme-light" : "text-dark"
          } card-link mr-4`}
        >
          <i className="fab fa-github" /> Stars{" "}
          <span className="badge badge-dark">{star_count}</span>
        </span>
      </a>
      {/*<small className={`${isDarkMode ? "theme-lightgray" : ""} text-muted`}>
        Updated {updated_at}
      </small>*/}
    </p>
  );
};

export default PortfolioCard;
